module.exports = __webpack_public_path__ + "img/muhyiddin_3.ce0a5792.jpg";